"use strict";
exports.__esModule = true;
exports.generateHashFrom = void 0;
var generateHashFrom = function (str) {
    return (str || '')
        .split('')
        .reduce(function (acc, value) {
        var hash = (acc << 5) - acc + value.charCodeAt(0);
        return hash & hash;
    }, 0)
        .toString(36)
        .substr(2, 5);
};
exports.generateHashFrom = generateHashFrom;
//# sourceMappingURL=generateHashFrom.js.map